import { Option } from './option';

export class OptionArea extends Option<string> {
    readonly type = 'area';
}
